import { render, staticRenderFns } from "./StateProp.vue?vue&type=template&id=5c5e80d8&scoped=true&"
import script from "./StateProp.vue?vue&type=script&lang=ts&"
export * from "./StateProp.vue?vue&type=script&lang=ts&"
import style0 from "./StateProp.vue?vue&type=style&index=0&id=5c5e80d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e80d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c5e80d8')) {
      api.createRecord('5c5e80d8', component.options)
    } else {
      api.reload('5c5e80d8', component.options)
    }
    module.hot.accept("./StateProp.vue?vue&type=template&id=5c5e80d8&scoped=true&", function () {
      api.rerender('5c5e80d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/debug/StateProp.vue"
export default component.exports